/// <amd-module name="Feed/Legacy/DataServices/RecycleBinDataService" />
import { Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { DataProviderConstants } from "Feed/Common/Constants/Constants";
import { Package, RecycleBinPackageVersion } from "Feed/Common/Contracts/Feed";
import { PackageDetailsResult, PackagesResult, WebPageData } from "Feed/Common/Contracts/WebPage";
import { getFeedClient, IFeedRestClient } from "Feed/Common/RestClient/Feed";
import { Feed, projId } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";
import * as Operations from "VSS/Platform/Contracts/Operations";

export class RecycleBinDataService extends VssService {
    private feedRestClient: IFeedRestClient;
    private contributionService: IVssContributionService;

    // todo: check why these are here, should be in webpagedataservice
    public getInitialPackagesResult(): PackagesResult {
        return this.getPackageHubData().recycleBinPackagesResult;
    }

    public getInitialPackageDetailsResult(): PackageDetailsResult {
        return this.getPackageHubData().packageDetailsResult;
    }

    /**
     * Should not be used directly other than PackageHubDataService which filters packages by enabled protocol
     */
    public getPackagesAsync(
        feed: Feed,
        protocolType: string,
        top: number,
        skip: number,
        packageNameQuery: string = null,
        includeAllVersions: boolean = false
    ): Promise<Package[]> {
        if (packageNameQuery === "") {
            packageNameQuery = null;
        }
        return this.FeedRestClient.getRecycleBinPackages(
            feed.id,
            projId(feed),
            protocolType, // ProtocolType
            packageNameQuery,
            null, // IncludeUrls,
            top,
            skip,
            includeAllVersions
        );
    }

    public getPackageVersionAsync(
        projectId: string,
        feedId: string,
        packageId: string,
        versionId: string
    ): Promise<RecycleBinPackageVersion> {
        return this.FeedRestClient.getRecycleBinPackageVersion(feedId, packageId, versionId, projectId, null);
    }

    public getPackageVersionsAsync(feed: Feed, packageId: string): Promise<RecycleBinPackageVersion[]> {
        return this.FeedRestClient.getRecycleBinPackageVersions(feed.id, packageId, projId(feed), null);
    }

    public emptyRecycleBinAsync(feed: Feed): Promise<Operations.OperationReference> {
        return this.FeedRestClient.emptyRecycleBin(feed.id, projId(feed));
    }

    private get FeedRestClient(): IFeedRestClient {
        if (this.feedRestClient == null) {
            this.feedRestClient = getFeedClient(this.pageContext);
        }
        return this.feedRestClient;
    }

    private getPackageHubData(): WebPageData {
        const webPageData =
            this.ContributionService.getData<WebPageData>(DataProviderConstants.PackageHubDataProvider) ||
            ({} as WebPageData);
        return webPageData;
    }

    private get ContributionService(): IVssContributionService {
        if (this.contributionService == null) {
            this.contributionService = this.pageContext.getService("IVssContributionService");
        }
        return this.contributionService;
    }
}

Services.add("IFeedRecycleBinDataService", { serviceFactory: RecycleBinDataService });
